// src/pages/auth/Signin.jsx
import React, { useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { loginUser, getDemoToken } from "../../../api/authApi";

const Signin = () => {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [demoLoading, setDemoLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const route = all_routes;

  const isPosSignin = location.pathname.startsWith("/pos");
  const fromState = location.state && location.state.from;

  const togglePasswordVisibility = () => setPasswordVisible((prev) => !prev);

  const goAfterLogin = () => {
    // If user tried to open a protected page, send them back
    if (fromState && fromState.pathname) {
      const { pathname, search, hash } = fromState;
      navigate(`${pathname}${search || ""}${hash || ""}`, { replace: true });
      return;
    }
    // Else go to POS root or Inventory dashboard
    navigate(isPosSignin ? route.pos : route.newdashboard, { replace: true });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const data = await loginUser(email, password);
      localStorage.setItem("token", data.token);
      localStorage.setItem("authToken", data.token);
      localStorage.removeItem("isDemo");
      goAfterLogin();
    } catch (err) {
      setError(err?.response?.data?.message || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  const handleDemoLogin = async () => {
    setError(null);
    setDemoLoading(true);
    try {
      const data = await getDemoToken(); // { token }
      localStorage.setItem("token", data.token);
      localStorage.setItem("authToken", data.token);
      localStorage.setItem("isDemo", "1");
      goAfterLogin();
    } catch (err) {
      setError(err?.response?.data?.message || "Unable to start demo");
    } finally {
      setDemoLoading(false);
    }
  };

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper bg-img">
          <div className="login-content authent-content">
            <form onSubmit={handleSubmit}>
              <div className="login-userset">
                <div className="login-logo logo-normal">
                  <ImageWithBasePath src="assets/img/logo.png" alt="img" />
                </div>
                <Link to={route.dashboard} className="login-logo logo-white">
                  <ImageWithBasePath src="assets/img/logo-white.png" alt="Img" />
                </Link>

                <div className="login-userheading">
                  <h3>{window.translate("Sign In")}</h3>
                  <h4 className="fs-16">
                    {window.translate(
                      isPosSignin
                        ? "Access the Hamilton POS panel using your email and passcode"
                        : "Access the Hamilton Inventory panel using your email and passcode"
                    )}
                  </h4>
                </div>

                {error && <div className="alert alert-danger py-2">{error}</div>}

                <div className="mb-3">
                  <label className="form-label">
                    {window.translate("Email")} <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="form-control border-end-0"
                      required
                    />
                    <span className="input-group-text border-start-0">
                      <i className="ti ti-mail" />
                    </span>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    {window.translate("Password")} <span className="text-danger">*</span>
                  </label>
                  <div className="pass-group">
                    <input
                      type={isPasswordVisible ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="pass-input form-control"
                      style={{ paddingRight: "40px" }}
                      required
                    />
                    <span
                      className={`ti toggle-password ${isPasswordVisible ? "ti-eye" : "ti-eye-off"}`}
                      onClick={togglePasswordVisibility}
                      role="button"
                      aria-label="Toggle password visibility"
                    />
                  </div>
                </div>

                <div className="form-login">
                  <button type="submit" className="btn btn-primary w-100" disabled={submitting || demoLoading}>
                    {submitting ? window.translate("Signing in") + "..." : window.translate("Sign In")}
                  </button>
                </div>

                <div className="d-flex align-items-center my-3">
                  <div className="flex-grow-1 border-top" />
                  <span className="px-2 text-muted small">{window.translate("OR")}</span>
                  <div className="flex-grow-1 border-top" />
                </div>

                <div className="form-login">
                  <button
                    type="button"
                    className="btn btn-outline-secondary w-100"
                    onClick={handleDemoLogin}
                    disabled={submitting || demoLoading}
                    title={window.translate("Preview POS & Inventory in read-only demo mode")}
                  >
                    {demoLoading
                      ? window.translate("Starting demo") + "..."
                      : window.translate("Continue as Demo (Read-only)")}
                  </button>
                </div>

                <div className="mt-3 small text-muted text-center">
                  {window.translate(
                    "In demo mode you can browse screens, but create/update/delete actions are blocked"
                  )}
                </div>

                <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                  <p>{window.translate("Copyright © 2025 Hamilton POS")}</p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
